var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39273 14.1868C5.37792 12.7476 6.99902 11.8125 9 11.8125C11.001 11.8125 12.622 12.7476 13.6072 14.1868M4.39273 14.1868C5.61796 15.2759 7.23172 15.9375 9 15.9375C10.7683 15.9375 12.382 15.2759 13.6072 14.1868M4.39273 14.1868C2.96314 12.9161 2.0625 11.0632 2.0625 9C2.0625 5.16853 5.16853 2.0625 9 2.0625C12.8315 2.0625 15.9375 5.16853 15.9375 9C15.9375 11.0632 15.0368 12.9161 13.6072 14.1868M11.4375 7.5C11.4375 8.84617 10.3462 9.9375 9 9.9375C7.65383 9.9375 6.5625 8.84617 6.5625 7.5C6.5625 6.1538 7.65383 5.0625 9 5.0625C10.3462 5.0625 11.4375 6.1538 11.4375 7.5Z",
    stroke: "#FF7926",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c1ee75f04004389272ff34fc5673efcb.svg";
export { ForwardRef as ReactComponent };